import { isRouteErrorResponse, useRouteError } from 'react-router'
import { ErrorFallback } from '@/components/common/ErrorFallback'
import { isApiError } from '@/lib/api/errors'

/** Error boundary for every route: shows a friendly message and a retry. */
export function RouteError() {
  const error = useRouteError()
  if (isRouteErrorResponse(error) && error.status === 404) {
    return <ErrorFallback title="Page not found" message="The page you're looking for doesn't exist." />
  }
  if (isApiError(error)) {
    return (
      <ErrorFallback message={error.message} requestId={error.requestId} onRetry={() => window.location.reload()} />
    )
  }
  if (import.meta.env.DEV) console.error(error)
  return (
    <ErrorFallback message="An unexpected error occurred. Please try again." onRetry={() => window.location.reload()} />
  )
}
